import { motion } from "framer-motion";
import { useLenis } from "@/hooks/useLenis";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import ProblemSection from "@/components/ProblemSection";
import WhatWeDoSection from "@/components/WhatWeDoSection";
import WhoWeServeSection from "@/components/WhoWeServeSection";
import WhyPlzSection from "@/components/WhyPlzSection";
import PortfolioSection from "@/components/PortfolioSection";
import Testimonial from "@/components/Testimonial";
import ContactSection from "@/components/ContactSection";
import Footer from "@/components/Footer";

export default function HomePage() {
  useLenis();
  return (
    <div data-testid="section-home" className="min-h-screen bg-plz-deep font-body text-plz-cream">
      <div className="noise-overlay" aria-hidden="true" />
      <Header />
      <motion.main initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.5 }}>
        <Hero />
        <Marquee />
        <ProblemSection />
        <WhatWeDoSection />
        <WhoWeServeSection />
        <WhyPlzSection />
        <PortfolioSection />
        <Testimonial />
        <ContactSection />
      </motion.main>
      <Footer />
    </div>
  );
}
